import * as React from 'react';
import styles from './styles.module.scss';

const WideCard = ({ children }) => {
  return <div className={styles['wide-card']}>{children}</div>;
};

export default WideCard;
